import { fetchRequest } from '@server/requests.js';
import { error } from '@sveltejs/kit';
import { browser } from '$app/environment';
import currentUserSession from '@utils/currentUserSession';

const API_URL = import.meta.env['VITE_API_URL'];

let fetchOpenGraph = async function (params, fetch) {
  let group;

  if (typeof window === 'undefined') {
    try {
      let key = `${params.username_or_id}|${params.slug}`;
      group = await (await fetch(`${API_URL}/api/groups/${key}/og`)).json();
    } catch {}
  }

  return {
    slug: params.slug,
    params: params,
    group: group,
  };
};

let fetchPrerender = async function (params, fetch, currentUser, reportedContent) {
  let data;
  let accessDenied = false;
  let unknownError = false;

  try {
    data = await fetchRequest({
      fetch,
      url: `/groups/${params.username_or_id}|${params.slug}/prerender`,
      method: 'GET',
      currentUser: currentUser,
    });
    if (!data.group.id || (reportedContent && reportedContent[`group_${data.group.id}`])) {
      throw error(404, { message: 'Not found', user: {} });
    }
  } catch (err) {
    if (err.status == 404) {
      const id = params.username_or_id;
      let user;
      if (id) {
        try {
          user = await (await fetch(`${API_URL}/api/users/${id}/og`)).json();
        } catch (err) {
          console.error(err);
        }
      }
      throw error(404, { message: 'Not found', user: user });
    } else if (err.status == 403) {
      throw error(404, { message: 'Not found', user: {} });
    } else if (err.status == 401) {
      accessDenied = true;
    } else if (err.status == 500) {
      unknownError = true;
    } else {
      console.error(err);
    }
  }

  return { data: data, accessDenied: accessDenied, unknownError: unknownError };
};

export async function load({ params, parent, fetch }) {
  let { currentUser, crawler, reportedContent } = await parent();

  if (browser) {
    currentUser = currentUserSession();
  }

  let og, prerenderData, group, sections, recs, recObjects;

  [prerenderData, og] = await Promise.all([
    fetchPrerender(params, fetch, currentUser, reportedContent),
    fetchOpenGraph(params, fetch),
  ]);

  let accessDenied = prerenderData.accessDenied;
  let unknownError = prerenderData.unknownError;

  if (prerenderData.data) {
    group = prerenderData.data.group || {};
    sections = prerenderData.data.sections || [];
    recs = prerenderData.data.recs || [];
    recObjects = prerenderData.data.rec_objects || [];
  }

  return {
    params,
    og,
    group,
    accessDenied,
    unknownError,
    sections,
    recs,
    recObjects,
    crawler,
  };
}
